export enum SourceConfiguration3dModelMarker {
  None,
  ModelFile = 10,
  Category
}
